<template>
    <div>
        <div style="width: 100%; height: 100%;" v-if="this.$store.state.device.isMobile">
            <navbarTop></navbarTop>
            <navbarBottom></navbarBottom>
            <div
                    class="container"
                    style="padding: 80px 16px 50px;margin: auto;"
            >
                <div class="input-group" style="padding-bottom: 25px;">
                    <input
                            @keyup.enter="search"
                            v-model="searchQuery"
                            type="text"
                            placeholder="Search number or name"
                            class="form-control search-bar-mobile"
                    />
                    <i class="fas fa-search search-mobile"></i>
                    <i v-if="this.searchQuery.length>0" v-on:click="clear" class="fas fa-times clear-mobile"></i>
                    <b-button class="btnSearch" v-on:click="search" variant="outline-primary">{{$t('standard.search')}}</b-button>
                </div>
                <section>
                    <b-table
                            :data="filteredData"
                            ref="table"
                            paginated
                            :per-page="rows_per_page"
                            detailed
                            detail-key="id"
                            aria-next-label="Next page"
                            aria-previous-label="Previous page"
                            aria-page-label="Page"
                            aria-current-label="Current page"
                            @click="(row, index) => toggle(row)"
                    >
                        <template slot-scope="props">
                            <a v-on:click="openModal(props.row.number, props.row)">
                                <img src="../../public/img/delete.svg" style="z-index: 900; width: 8%; top: 4%; left: 4%; position: absolute;">
                            </a>

                            <b-table-column field="number" :label="$t('pages.List.ColumnNumber')">
                                {{ props.row.number }}
                            </b-table-column>

                            <b-table-column field="name" :label="$t('pages.List.ColumnName')">
                                {{ props.row.name }}
                            </b-table-column>

                            <b-table-column field="email" :label="$t('pages.List.ColumnEmail')">
                                {{ props.row.email }}
                            </b-table-column>

                            <b-table-column field="phone_number" :label="$t('pages.List.ColumnPhone')">
                                <a :href="'tel:'+props.row.phone_number"  data-rel="external">{{ props.row.phone_number }}</a>
                            </b-table-column>

                            <b-table-column v-if="props.row.type==1" field="type" label="Tipo">
                                Normal
                            </b-table-column>
                            <b-table-column v-if="props.row.type==2" field="type" label="Tipo">
                                Idoso
                            </b-table-column>
                            <b-table-column v-if="props.row.type==3" field="type" label="Tipo">
                                Criança
                            </b-table-column>
                            <b-table-column v-if="props.row.type==4" field="type" label="Tipo">
                                Atleta
                            </b-table-column>
                            <b-table-column v-if="props.row.type==5" field="type" label="Tipo">
                                Mulher
                            </b-table-column>

                            <b-table-column :label="$t('pages.List.ColumnStatus')" v-if="props.row.status == 1">
                                <span class="tag is-success" style="border-radius: 32px;">{{ $t('pages.List.Ok') }}</span>
                            </b-table-column>

                            <b-table-column :label="$t('pages.List.ColumnStatus')" v-if="props.row.status == 2">
                                <span class="tag is-danger" style="border-radius: 32px;">{{ $t('pages.List.Delay') }}</span>
                                <b-button v-if="props.row.send_alert_email == 0" class="btnSend" v-on:click="sendAlertEmail(props.row.number, props.row.email, props.row)">
                                    <img src="../../public/img/send.svg" style="z-index: 900; width: 20%;">
                                    {{ $t('pages.List.notifyMember') }}
                                </b-button>
                                <b-button v-if="props.row.send_alert_email == 1" class="btnSend_disabled" v-on:click="toastAlertEmail(props.row)">
                                    <img src="../../public/img/send.svg" style="z-index: 900; width: 20%;">
                                    {{ $t('pages.List.notifyMember') }}
                                </b-button>
                            </b-table-column>


                            <b-button class="btnPayment" v-on:click="payment(props.row)" style="border-radius: 0">{{ $t('pages.List.PaymentButton') }}</b-button>
                        </template>

                        <template style="margin-top: 0; padding-top: 0;" slot="detail" slot-scope="props">
                            <article class="media">
                                <div class="media-content">
                                    <div class="content">
                                        <div class="modal-body" style="padding: 0">

                                            <!-- Name input-->
                                            <div class="form-group">
                                                <label class="control-label">{{ $t('pages.List.ColumnName') }}</label>
                                                <input
                                                        v-model="props.row.name"
                                                        name="name"
                                                        type="text"
                                                        class="form-control"
                                                />
                                            </div>

                                            <!-- Email input-->
                                            <div class="form-group">
                                                <label class="control-label">{{ $t('pages.List.ColumnEmail') }}</label>
                                                <input
                                                        v-model="props.row.email"
                                                        placeholder="example@example.pt"
                                                        name="email"
                                                        type="email"
                                                        class="form-control"
                                                />
                                            </div>

                                            <!-- Telemovel input-->
                                            <div class="form-group">
                                                <label class="control-label">{{ $t('pages.List.ColumnPhone') }}</label>
                                                <VuePhoneNumberInput  v-model="props.row.phone_number" />
                                            </div>


                                            <!-- Address input -->
                                            <div class="form-group">
                                                <label class="control-label">{{ $t('pages.List.ColumnAddress') }}</label>
                                                <gmap-autocomplete
                                                        :placeholder="props.row.address"
                                                        @place_changed="setPlace"
                                                        :value="props.row.address"
                                                        @input="value = $event.target.value"
                                                        class="form-control"
                                                        style="width: 100%">
                                                </gmap-autocomplete>
                                            </div>

                                            <!-- Observações input-->
                                            <div class="form-group">
                                                <label class="control-label">{{ $t('pages.List.ColumnNotes') }}</label>
                                                <input
                                                        v-model="props.row.notes"
                                                        name="notes"
                                                        type="text"
                                                        class="form-control"
                                                />
                                            </div>

                                            <!-- Age input-->
                                            <div class="form-group">
                                                <label class="control-label">{{ $t('pages.List.ColumnBirthdayDate') }}</label>
                                                <b-form-input
                                                        type="date"
                                                        v-model="props.row.birthday_date"
                                                ></b-form-input>
                                            </div>

                                            <!-- Type input-->
                                            <div class="form-group">
                                                <label class="control-label">{{ $t('pages.Registration.MemberType') }}</label>
                                                <b-form-select
                                                        style="border-radius: 22px"
                                                        v-model="props.row.type"
                                                        :options="options_type"
                                                ></b-form-select>
                                            </div>

                                        </div>

                                        <div class="modal-footer" style="padding: 0">
                                            <b-button
                                                    class="btnUpdate"
                                                    v-on:click="updateSocio(props.row)"
                                                    style="width: 100%; margin: 0; margin-top: 25px"
                                            >
                                                {{ $t('pages.List.UpdateButton') }}
                                            </b-button>
                                        </div>

                                    </div>
                                </div>
                            </article>
                        </template>
                    </b-table>
                </section>
            </div>
        </div>
        <div v-if="this.$store.state.device.isDesktop">
            <navbarTop></navbarTop>
            <sideBar></sideBar>
            <div class="desktop_container">
                <div class="input-group" style="padding-bottom: 25px;">
                    <input
                            @keyup.enter="search"
                            v-model="searchQuery"
                            type="text"
                            placeholder="Search number or name"
                            class="form-control search-bar-desktop"
                    />
                    <i class="fas fa-search search-desktop"></i>
                    <i v-if="this.searchQuery.length>0" v-on:click="clear" class="fas fa-times clear-desktop"></i>
                    <b-button class="btnSearch search-button-desktop" v-on:click="search">{{$t('standard.search')}}</b-button>
                </div>
                <section>
                    <b-table
                            :data="filteredData"
                            ref="table"
                            paginated
                            :per-page="rows_per_page"
                            aria-next-label="Next page"
                            aria-previous-label="Previous page"
                            aria-page-label="Page"
                            aria-current-label="Current page"
                    >
                        <template slot-scope="props">
                            <b-table-column field="number" :label="$t('pages.List.ColumnNumber')">
                                {{ props.row.number }}
                            </b-table-column>

                            <b-table-column field="name" :label="$t('pages.List.ColumnName')">
                                {{ props.row.name }}
                            </b-table-column>

                            <b-table-column field="email" :label="$t('pages.List.ColumnEmail')">
                                {{ props.row.email }}
                            </b-table-column>

                            <b-table-column field="phone_number" :label="$t('pages.List.ColumnPhone')">
                                <a :href="'tel:'+props.row.phone_number"  data-rel="external">{{ props.row.phone_number }}</a>
                            </b-table-column>

                            <b-table-column v-if="props.row.type==1" field="type" label="Tipo">
                                Normal
                            </b-table-column>
                            <b-table-column v-if="props.row.type==2" field="type" label="Tipo">
                                Idoso
                            </b-table-column>
                            <b-table-column v-if="props.row.type==3" field="type" label="Tipo">
                                Criança
                            </b-table-column>
                            <b-table-column v-if="props.row.type==4" field="type" label="Tipo">
                                Atleta
                            </b-table-column>
                            <b-table-column v-if="props.row.type==5" field="type" label="Tipo">
                                Mulher
                            </b-table-column>

                            <b-table-column :label="$t('pages.List.ColumnStatus')" v-if="props.row.status == 1">
                                <span class="tag is-success" style="border-radius: 32px;">{{ $t('pages.List.Ok') }}</span>
                            </b-table-column>

                            <b-table-column :label="$t('pages.List.ColumnStatus')" v-if="props.row.status == 2">
                                <span class="tag is-danger" style="border-radius: 32px;">{{ $t('pages.List.Delay') }}</span>
                            </b-table-column>

                            <b-table-column :label="$t('pages.List.ColumnPayment')">
                                <b-button class="btnPayment" v-on:click="payment_desktop(props.row)" style="border-radius: 32px;">{{ $t('pages.List.PaymentButton') }}</b-button>
                            </b-table-column>

                            <b-table-column :label="$t('pages.List.ColumnEdit')">
                                <a v-on:click="edit(props.row)">
                                    <img src="img/edit.svg">
                                </a>
                            </b-table-column>

                            </template>
                    </b-table>
                </section>
            </div>
        </div>
    </div>
</template>


<script>
    import NavbarTop from "../components/navbarTop";
    import navbarBottom from "../components/navbarBottom";
    import sideBar from "../components/sideBar"
    import VuePhoneNumberInput from "vue-phone-number-input";
    import {getAll, updateMember, deleteMember, sendAlertEmail} from "../api/Member/apiMember.js";
    import "buefy/dist/buefy.css";
    import { BModal } from 'bootstrap-vue'
    const pt = require('../translations/pt-PT/pt-PT');
    const en = require('../translations/en-GB/en-GB');

    export default {
        name: "listSocios",
        components: {
            NavbarTop,
            navbarBottom,
            sideBar,
            VuePhoneNumberInput,
            BModal
        },
        data() {
            return {
                activeModalNumber: null,
                data: [],
                filteredData: [],
                searchQuery: "",
                defaultOpenedDetails: [1],
                showDetailIcon: true,
                rows_per_page: 7,
                address: "",
                options_type: [{ value: 1, text: "Normal" },
                                { value: 2, text: "Idoso" },
                                { value: 3, text: "Criança" },
                                { value: 4, text: "Atleta" },
                                { value: 5, text: "Mulher" }]
            };
        },
        methods: {
            openModal(number, row) {
                this.toggle(JSON.stringify(row));
                if(this.$i18n.locale()=='pt'){
                    this.$bvModal.msgBoxConfirm(pt.pages.List.confirmModal, {
                        title: pt.pages.List.titleModal+''+number,
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: pt.pages.List.oktitleModal,
                        cancelTitle: pt.pages.List.canceltitleModal,
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                        .then(value => {
                            if(value) this.deleteSocio(number);
                        })
                        .catch(error => { })
                }else if(this.$i18n.locale()=='en'){
                    this.$bvModal.msgBoxConfirm(en.pages.List.confirmModal, {
                        title: en.pages.List.titleModal+''+number,
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: en.pages.List.oktitleModal,
                        cancelTitle: en.pages.List.canceltitleModal,
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                        .then(value => {
                            if(value) this.deleteSocio(number);
                        })
                        .catch(error => { })
                }
            },
            clear(){
                this.searchQuery = '';
                this.filteredData = this.data;
            },
            search() {
                let spinner = this.$loading.open();

                var query = new RegExp(this.searchQuery, "i");
                var data = [];
                if(query == ""){
                    this.filteredData = this.data;
                    spinner.close();
                }else{
                    for (var i in this.data) {
                        if ( this.data[i].name.match(query) || this.data[i].number.match(query) ) {
                            data.push(this.data[i]);
                        }
                    }
                    this.filteredData = data;
                    spinner.close();
                }
            },
            toggle(row) {
                this.$refs.table.toggleDetails(row);
            },
            updateSocio: function(row) {
                let update_data = {
                    name: row.name,
                    birthday_date: row.birthday_date,
                    phone_number: row.phone_number,
                    address: this.address,
                    member_email: row.email,
                    notes: row.notes,
                    type: row.type
                };
                let spinner = this.$loading.open();
                updateMember(row.number, update_data)
                        .then(response => {
                            let members = JSON.parse(localStorage.getItem('members'));
                            members.forEach(obj => {
                                if(obj.number == row.number) {
                                    obj.name = row.name;
                                    obj.birthday_date = row.birthday_date;
                                    obj.phone_number = row.phone_number;
                                    obj.address = address;
                                    obj.email = row.email;
                                    obj.notes = row.notes;
                                    obj.type = row.type;
                                }
                            })
                            localStorage.setItem('members', JSON.stringify(members));
                            spinner.close();
                            if(this.$i18n.locale()=='pt') this.$toast.open(pt.pages.List.messageUpdate);
                            if(this.$i18n.locale()=='en') this.$toast.open(en.pages.List.messageUpdate);
                            this.toggle(row);
                        })
                        .catch(error => {
                            spinner.close();
                            if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                            else{
                                let response_error = error.response.data;
                                this.$toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                            }
                        });
            },
            setPlace(place) {
                this.address = "" + place.name;
            },
            payment: function(row){
                this.toggle(row);
                this.$router.push({
                    name: 'Pagamento',
                    params: {
                        row: row
                    }
                })
            },
            payment_desktop: function(row){
                this.toggle(row);
                this.$router.push({
                    name: 'Edit',
                    params: {
                        row: row,
                        payment: true
                    }
                })
            },
            edit: function(row){
                this.toggle(row);
                this.$router.push({
                    name: 'Edit',
                    params: {
                        row: row,
                        payment: false
                    }
                })
            },
            deleteSocio(number) {
                let spinner = this.$loading.open();
                deleteMember(number)
                    .then(response => {
                        spinner.close();
                        if (response.data.body.changedRows == 1) {
                            let members = JSON.parse(localStorage.getItem('members'));
                            for(var i=0; i<members.length; i++) {
                                if(members[i].number == number) members.splice(i,1);   
                            }
                            localStorage.setItem('members', JSON.stringify(members));

                            if(this.$i18n.locale()=='pt') this.$toast.open(pt.pages.List.messageDelete);
                            if(this.$i18n.locale()=='en') this.$toast.open(en.pages.List.messageDelete);
                            this.$router.go(0);
                        } else {
                            this.$toast.open({
                                message: 'Algo não correu bem. Tente novamente',
                                type: 'is-danger'
                            })
                        }
                    })
                    .catch(error => {
                        spinner.close();
                        if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                        else{
                            let response_error = error.response.data;
                            this.$toast.open({
                                message: response_error[Object.keys(response_error)[0]].msg.code,
                                type: 'is-danger',
                            });
                        }
                    })
            },
            toastAlertEmail(row) {
                this.toggle(row);
                if(this.$i18n.locale()=='pt'){
                    this.$toast.open({
                        message: pt.pages.List.messageAlreadyNotify,
                        duration: 3500,
                        type: 'is-danger'
                    });
                } else if(this.$i18n.locale()=='en'){
                    this.$toast.open({
                        message: en.pages.List.messageAlreadyNotify,
                        duration: 3500,
                        type: 'is-danger'
                    });
                }
            },
            sendAlertEmail(number, email, row){
                let spinner = this.$loading.open();
                this.toggle(row);
                let data = {};
                data.number = number;
                data.email = email;
                sendAlertEmail(data)
                    .then((response) => {
                        let members = JSON.parse(localStorage.getItem('members'));
                        members.forEach(obj => {
                            if(obj.number == number) {
                                obj.send_alert_email = 1;
                            }
                        })
                        localStorage.setItem('members', JSON.stringify(members));
                        spinner.close();
                        if(this.$i18n.locale()=='pt'){
                            this.$toast.open({
                                message: pt.pages.List.messageSent,
                                duration: 3500,
                            });
                            this.$router.go();
                        } else if(this.$i18n.locale()=='en'){
                            this.$toast.open({
                                message: en.pages.List.messageSent,
                                duration: 3500,
                            });
                            this.$router.go();
                        }
                    })
                    .catch(error => {
                        spinner.close();
                        if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                        else{
                            let response_error = error.response.data;
                            this.$toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                        }
                    })
            },
            validateJSON(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
            },
            getMembers() {
                let spinner = this.$loading.open();
                getAll()
                    .then(response => {
                        for (var i = 0; i < response.data.body.length; i++) {
                            response.data.body[i].number = response.data.body[i].number.toString();
                            if(response.data.body[i].email=='undefined' || response.data.body[i].email=='null') response.data.body[i].email='';
                            if(response.data.body[i].phone_number=='undefined' || response.data.body[i].phone_number=='null') response.data.body[i].phone_number='';
                            if(response.data.body[i].notes=='undefined' || response.data.body[i].notes=='null') response.data.body[i].notes='';
                            if(response.data.body[i].address=='undefined' || response.data.body[i].address=='null') response.data.body[i].address='';
                        }
                        this.data = response.data.body;
                        this.filteredData = response.data.body;
                        localStorage.setItem('members', JSON.stringify(response.data.body));
                        spinner.close();
                    })
                    .catch(error => {
                        spinner.close();
                        if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                        else this.$toast.open({message: "Algo correu mal...", type: 'is-danger'});
                    });
            }
        },
        mounted() {
            if(this.$store.state.device.isDesktop) this.rows_per_page = 7;
            if(localStorage.getItem('members') !== null) {
                if(this.validateJSON(localStorage.getItem('members'))) {
                    let spinner = this.$loading.open();
                    this.data = JSON.parse(localStorage.getItem('members'));
                    this.filteredData = JSON.parse(localStorage.getItem('members'));
                    spinner.close();
                }else {this.getMembers();}
            }else {this.getMembers();}       
        }
    };
</script>



<style scoped>
    @media (max-width: 325px) {
        .btnSearch {
            height: 125%;
            width: 30%;
            background: #2B2D42 0% 0% no-repeat padding-box;
            border-radius: 32px;
            color: white;
            border: none;
            letter-spacing: 0.85px;
            font-size: 12px;
            padding-top: 10px;
            padding-bottom: 10px;
            margin-right: 5px;
        }
    }
    @media (min-width: 325px) {
        .btnSearch {
            height: 100%;
            width: 30%;
            background: #2B2D42 0% 0% no-repeat padding-box;
            border-radius: 32px;
            color: white;
            border: none;
            letter-spacing: 0.85px;
            margin-right: 5px;
        }
    }

    .btnPayment {
        height: 100%;
        width: 100%;
        background: #2B2D42 0% 0% no-repeat padding-box;
        color: white;
        border: none;
        letter-spacing: 0.85px;
    }
    .btnUpdate {
        height: 100%;
        width: 100%;
        background: #2B2D42 0% 0% no-repeat padding-box;
        border-radius: 32px;
        color: white;
        border: none;
        letter-spacing: 0.85px;
    }
    .btnSend {
        height: 50%;
        width: 100%;
        background: white 0% 0% no-repeat padding-box;
        border-radius: 32px;
        color: #2B2D42;
        border-color: #2B2D42;
        letter-spacing: 0.85px;
        padding: 0 5%;
        margin-top: 5%;
    }
    .btnSend_disabled {
        height: 50%;
        width: 100%;
        background: #cccccc 0% 0% no-repeat padding-box;
        border-radius: 32px;
        color: #2B2D42;
        border-color: #2B2D42;
        letter-spacing: 0.85px;
        padding: 0 5%;
        margin-top: 5%;
    }
    @media (max-width: 330px) {
        ::placeholder {
            font-size: 90%;
        }
    }
    input {
        padding-left: 10%;
    }

    .search-mobile {
        position: absolute;
        left: 12px;
        padding-top: 12px;
        color: #2B2D42;
        z-index: 100;
    }
    .clear-mobile {
        position: absolute;
        right: 38%;
        padding-top: 12px;
        color: #2B2D42;
        z-index: 100;
    }
    .search-bar-mobile {
        margin-right: 5px;
        border-radius: 32px;
    }
    .search-button-mobile {
        margin-right: 5px;
        width: 20%;
    }


    .search-desktop {
        position: absolute;
        left: 20px;
        padding-top: 12px;
        color: #2B2D42;
        z-index: 100;
    }
    .clear-desktop {
        position: absolute;
        right: 24%;
        padding-top: 12px;
        color: #2B2D42;
        z-index: 100;
    }
    .search-bar-desktop {
        margin-right: 5px;
        border-radius: 32px;
        padding-left: 60px;
        width: 80%;
    }
    .search-button-desktop {
        margin-right: 5px;
        width: 20%;
    }
</style>
